// API Configuration for NFT Indexer
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://nftapi.etcmc-monitor.org',
  ENDPOINTS: {
    NFTS: '/api/nfts',
    NFT_BY_ID: '/api/nfts',
    SYNC_STATUS: '/api/sync-status',
    HEALTH: '/api/health',
    SYNC: '/api/sync',
    FULL_SYNC: '/api/full-sync'
  },
  DEFAULT_LIMIT: 100,
  DEFAULT_OFFSET: 0
};

// Helper function to build API URLs
export const buildApiUrl = (endpoint, params = {}) => {
  const url = new URL(`${API_CONFIG.BASE_URL}${endpoint}`);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      url.searchParams.append(key, value);
    }
  });
  return url.toString();
};

// Error handling for API responses
export const handleApiError = (error) => {
  console.error('API Error:', error);
  
  if (error.name === 'TypeError' && error.message.includes('fetch')) {
    throw new Error('Unable to connect to the NFT indexer. Please ensure it is running.');
  }
  
  if (error.response) {
    const status = error.response.status;
    switch (status) {
      case 404:
        throw new Error('NFT not found');
      case 500:
        throw new Error('Server error. Please try again later.');
      default:
        throw new Error(`API error: ${status}`);
    }
  }
  
  throw error;
};
